import React from 'react'

export const FacturaPedido = React.forwardRef((props, ref) => {
    const datosFactura = props.data

    return (
        <div className="cont_tiket_factura" ref={ref}>
            <h4>Blue Moon Beauty SD</h4>
            <span>Principal</span><br />
            <span>https://bluemoonbeautysd.com</span><br />
            <hr className="lineaFactura" />

            <span>DETALLE DEL CLIENTE:</span><br />
            <div className="combina_tiquete" style={{ textAlign: 'left' }}>
                <span>Nombre: {datosFactura.cliente.nombre}</span><br />
                <span>Teléfono: {datosFactura.cliente.tel}</span><br />
                <span>Email: {datosFactura.cliente.email}</span><br />
            </div>

            <hr className="lineaFactura" />

            <span>DETALLE DE ENVIO:</span><br />
            <div className="combina_tiquete" style={{ textAlign: 'left' }}>
                <span>País: {datosFactura.cliente.pais}</span><br />
                <span>Estado: {datosFactura.cliente.estado}</span><br />
                <span>Ciudad: {datosFactura.cliente.ciudad}</span><br />
                <span>Dirección: {datosFactura.cliente.direccion}</span><br />
                <span>ZipCode: {datosFactura.cliente.zip}</span><br />
            </div>

        </div>
    );
});